import { render, staticRenderFns } from "./ListaCadastrosPlano.vue?vue&type=template&id=2f87956d&scoped=true&"
import script from "./ListaCadastrosPlano.vue?vue&type=script&lang=js&"
export * from "./ListaCadastrosPlano.vue?vue&type=script&lang=js&"
import style0 from "./ListaCadastrosPlano.vue?vue&type=style&index=0&id=2f87956d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87956d",
  null
  
)

export default component.exports